exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-package .slick-dots li button::before {\n  color: #FFF !important;\n}\n.service-package .slick-track {\n  margin: 0 auto !important;\n}", ""]);

// exports
